import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetSpecialOffersQuery,
  useGetHomepageSettingsQuery,
} from "../redux/services/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";
import { createExcerpt } from "../utils/excerpt";
import { useTranslation } from "../hooks/useTranslation";
import { trackOffersPage } from "../utils/analytics";
import AOS from "aos";
import "aos/dist/aos.css";

const OffersPage = () => {
  const navigate = useNavigate();
  const { t, isArabic } = useTranslation();

  // Use RTK Query to fetch offers
  const { data: offersResponse, isLoading: loading } =
    useGetSpecialOffersQuery();
  const { data: settingsResponse } = useGetHomepageSettingsQuery();

  const offers =
    offersResponse?.offers?.filter((offer) => offer.is_active) || [];
  const logoUrl = settingsResponse?.settings?.branding?.logo || null;

  // Initialize AOS and track page visit
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
    trackOffersPage();
  }, []);

  const handleOfferClick = (offerId) => {
    navigate(`/offer/${offerId}`);
  };

  if (loading) {
    return (
      <div className="offers-page">
        <div className="container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>{t("offers.loadingOffers")}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="offers-page">
      <Header />
      <div className="container">
        {/* Page Title */}
        <div
          className="page-title-section"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1>{t("offers.title")}</h1>
          <p>{t("offers.description")}</p>
        </div>

        {/* Offers Grid */}
        <div className="offers-grid-page">
          {offers.length === 0 ? (
            <div className="no-offers" data-aos="fade-up" data-aos-delay="200">
              <p>{t("offers.noOffers")}</p>
            </div>
          ) : (
            offers.map((offer, index) => (
              <div
                key={offer.id}
                className="offer-item clickable-offer-item"
                data-aos="zoom-in"
                data-aos-delay={`${200 + index * 150}`}
                onClick={() => handleOfferClick(offer.id)}
                style={{ cursor: "pointer" }}
              >
                <div className="offer-content">
                  <div className="offer-title-box">
                    <span>
                      {isArabic && offer.title_ar
                        ? offer.title_ar
                        : offer.title}
                    </span>
                  </div>
                  <div className="offer-description">
                    {createExcerpt(
                      isArabic && offer.content_ar
                        ? offer.content_ar
                        : offer.content,
                      20
                    )}
                  </div>
                </div>
                <div className="offer-image-container">
                  {offer.image_url ? (
                    <img
                      src={offer.image_url}
                      alt={
                        isArabic && offer.title_ar
                          ? offer.title_ar
                          : offer.title
                      }
                      className="offer-image"
                    />
                  ) : (
                    <div className="offer-placeholder">
                      <span>{t("offers.offerPic")}</span>
                    </div>
                  )}
                </div>
                {index < offers.length - 1 && (
                  <div className="offer-separator"></div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
      {/* Footer */}
      <Footer />
      {/* Floating Buttons */}
      <FloatingButtons />
    </div>
  );
};

export default OffersPage;
